<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs11, sm10, md9, lg8, text-xs-center)
          v-card(flat)
            breadcrumb(back='page10-3')
              | Estás en: Elige tu Crédito Hipotecario / ¡Quiero saber cómo me protege un Crédito Hipotecario!
            v-card-text.text-xs-center.label16tt.withDivider
              | PREGUNTA 3 DE 4
            img.pt-3(style="width:61px; heigth:67px;", src="assets/cronometro.gif")
            v-card-text.chrono
              b {{("0" + Math.floor(time / 60)).slice(-2) +":" + ("0"+(time - Math.floor(time / 60) * 60)).slice(-2)}}
            v-card-text.titulo24Reg.text-center
              | Existen otras variables que te ayudarán a comparar las opciones de Crédito Hipotecario que ofrecen los diferentes bancos. Conocer su funcionamiento es clave para concluir el diseño de tu plan. 
            v-card-text.parrafoDestacadoB.text-center  De las siguientes afirmaciones, selecciona aquellas que son verdaderas. 
            v-card.questionCard(justify-center, flat)
              v-layout.ml-5.my-0.py-0(v-for='(reactivo, index) in reactivos', :key='index')
                v-flex(xs1, offset-xs1, align-center, align-content-center)
                  v-icon(size='15px', color='green', v-if='sent && (reactivo.resultado === 1)') fas fa-check
                  v-icon(size='15px', color='red', v-if='sent && (reactivo.resultado === 0)') fas fa-times
                v-flex(xs1)
                  v-checkbox(style="margin-top: -7px;", hide-details, v-model='reactivo.respuesta')
                v-flex.parrafoDestacadoB.text-xs-left.py-2(xs10, align-content-center)
                  | {{reactivo.descripcion}}
              v-spacer.pb-4
            v-layout(row, justify-center)
              v-flex
                div(v-if=' sent==false ')
                  v-btn.btn(color='secondary ', @click='sendResult() ')
                    | Enviar
                div(v-if='sent ')
                  v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                    | Ver Retroalimentación
                  v-dialog(v-model='dialog ', persistent, max-width='930px ')
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          .pt-1(v-if='sent && (response==1) ')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoArriba.png ')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | Excelente!
                            v-card.questionCard(flat)
                              v-layout(align-center justify-center row fill-height)
                                v-flex(xs8).text-xs-left
                                  v-card-text.parrafoDestacadoB 
                                    b ¡Acertaste! 
                                    | Sabes bien que:
                                    v-spacer.my-4
                                    ul
                                      li.parrafoDestacadoB
                                        b Se recomienda destinar como máximo el 30% de tus ingresos para pagar tu Crédito Hipotecario.
                                      li.parrafoDestacadoB
                                        b Hay bancos que te permiten realizar pagos anticipados, ya sea a plazo o a mensualidades. 
                                      li.parrafoDestacadoB
                                        b El CAT real puede variar de acuerdo a cómo administres tu crédito.
                                      li.parrafoDestacadoB
                                        b El porcentaje máximo que te prestará cualquier banco para financiar el costo del inmueble es 90%. 
                          .pt-1.pr-2(v-if='sent && (response!=1) ')
                            v-layout(row, justify-center)
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoStop.png ')
                            v-spacer.my-1.py-4
                            v-card-text.headline
                              | Hay una mejor respuesta...
                            v-card.questionCard(flat)
                             v-layout(align-center justify-center row fill-height)
                                v-flex(xs8).text-xs-left
                                  v-card-text.parrafoDestacadoB 
                                    b ¡Lo sentimos! 
                                    | Es muy importante que recuerdes que:
                                    v-spacer.my-4
                                    ul
                                      li.parrafoDestacadoB
                                        b Se recomienda destinar como máximo el 30% de tus ingresos para pagar tu Crédito Hipotecario.
                                      li.parrafoDestacadoB
                                        b Hay bancos que te permiten realizar pagos anticipados, ya sea a plazo o a mensualidades. 
                                      li.parrafoDestacadoB
                                        b El CAT real puede variar de acuerdo a cómo administres tu crédito.
                                      li.parrafoDestacadoB
                                        b El porcentaje máximo que te prestará cualquier banco para financiar el costo del inmueble es 90%. 
                          v-btn.btn.dialog_btn(color='accent ', @click.prevent="nextPage( 'page10-5') ")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import jsPDF from 'jspdf';
import {
  eventBus
} from '../main';
export default {
  name: 'app',
  deactivated() {
    this.time = 135;
    this.timer = null;
  },
  activated() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        if ((this.time > 0) && !this.sent) {
          this.time--
        } else {
          clearInterval(this.timer);
          if (!this.sent) {
            this.sendResult();
            this.nextPage('p05');
          }
        }
      }, 1000)
    }
  },
  data() {
    return {
      selected: [],
      feedback: false,
      dialog: false,
      response: 'none',
      sent: false,
      show: false,
      correcta: false,
      time: 135,
      timer: null,
      interaction : {
        id : "TCH.L2.p10-4",
        questionText : "Completa la frase",
        learnerResponse: "",
        correctAnswer : "",
        wasCorrect : true
      },
      reactivos: [{
          descripcion: 'Un buen cálculo está basado en la idea de destinar el 30% de tus ingresos al pago de tu Crédito Hipotecario.',
          correcta: true,
          respuesta: false,
          resultado: 0
        },
        {
          descripcion: 'Hay bancos que te permiten realizar Pagos Anticipados, ya sea a plazo o a mensualidades. ',
          correcta: true,
          respuesta: false,
          resultado: 0
        },
        {
          descripcion: 'El CAT real puede variar de acuerdo a cómo administres tu crédito.',
          correcta: true,
          respuesta: false,
          resultado: 0
        },
        {
          descripcion: 'Un buen cálculo está basado en la idea de destinar el 50% de tus ingresos al pago de tu Crédito Hipotecario. ',
          correcta: false,
          respuesta: false,
          resultado: 0
        },
        {
          descripcion: 'Existen bancos que te prestarán el 100% del costo del inmueble.',
          correcta: false,
          respuesta: false,
          resultado: 0
        },
      ]
    }
  },
  computed: {
    completo: function() {
      var complete = true;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == 'none') {
          complete = false;
        }
      })
      return complete;
    },
    resultado: function() {
      var resultado = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == reactivo.correcta) {
          resultado++;
        }
      })
      resultado = resultado / this.reactivos.length
      return resultado;
    }
  },
  methods: {
    grade: function() {
      var points = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.correcta == reactivo.respuesta) {
          reactivo.resultado = 1;
          points++;
        }
      });
      this.resultado = points / this.reactivos.length;
    },
    sendResult() {
      this.grade();
      this.sent = true;
      eventBus.$emit('send_result', this.resultado);
      eventBus.$emit('suspend_data', this.reactivos);
      this.response = this.resultado;
    },
    downloadPDF() {
      var lineSpace = 7;
      var doc = new jsPDF()
      doc.text('Cumplimiento de requisitos para Crédito Hipotecario', 10, 10)
      doc.setFontSize(12);
      this.reactivos.forEach(function(reactivo, index) {
        if (reactivo.respuesta) {
          doc.setTextColor(0, 255, 0);
          doc.text("[Cumple]", 10, 20 + lineSpace * index);
        } else {
          doc.setTextColor(255, 0, 0);
          doc.text("[No Cumple]", 10, 20 + lineSpace * index);
        }
        doc.setTextColor(0, 0, 0);
        doc.text(reactivo.descripcion, 35, 20 + lineSpace * index);
      })
      doc.save('requisitos.pdf')
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    nextChapter(page) {
      this.progress = true;
      eventBus.$emit('next_chapter', page);
    },
    testValue(value, test) {
      if (value == test) {
        return 'accent';
      }
      return 'greyNormal'
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  }
};
</script>
